// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Guam from '../_raw/flag/icon_flag_guam.png';

export default () => <img src={Guam} alt="Guam" />;
